import React, { useEffect, useState } from 'react';
import { twMerge } from 'tailwind-merge';
import '../../utils/Flows';
import { WidgetHeader } from './WidgetHeader/WidgetHeader';
import { getURLParamValue } from '../../../clearstep/util/AppHelpers';
import { MobileStates } from '../Widget';
export var WidgetConvo = function (props) {
    var path = props.path, setWorkflow = props.setWorkflow, shortTitle = props.shortTitle, singleFlow = props.singleFlow, sessionId = props.sessionId, setWidgetState = props.setWidgetState, mobileState = props.mobileState;
    var _a = useState(), iframeSrc = _a[0], setIframeSrc = _a[1];
    var isSingleFlowMobile = !!singleFlow && mobileState === MobileStates.MOBILE;
    useEffect(function () {
        if (typeof URL !== 'undefined') {
            if (sessionId) {
                // Pass the widget session ID via url param to the convo for logging
                var basePath = window.location.origin + path;
                var url = new URL(basePath);
                url.searchParams.set('widgetSessionId', sessionId);
                var p = url.toString();
                setIframeSrc(p);
            }
        }
        else {
            setIframeSrc(window.location.origin + path);
        }
    }, [sessionId]);
    var customHeaderText = getURLParamValue('widgetOverrideHeaderText');
    return (React.createElement(React.Fragment, null,
        React.createElement(WidgetHeader, { setWorkflow: setWorkflow, className: "animate-widget-fade-in", headerText: customHeaderText || shortTitle, singleFlow: singleFlow, setWidgetState: setWidgetState, mobileState: mobileState }),
        iframeSrc && (React.createElement("iframe", { src: iframeSrc, className: twMerge('w-full animate-widget-fade-in rounded-b-2xl border-0', isSingleFlowMobile
                ? 'h-widget-convo-ext-header' /* Need more header room for 2 rows, so convo h is less */
                : 'h-widget-convo'), "data-cy": "widget__workflow__iframe", id: "widget__iframe", title: "widget__iframe" }))));
};
export default WidgetConvo;
